<template>
  <Modal :title="title" @backdrop-click="closeWithReseting">
    <template slot="body">
      <form v-if="!withoutSearchForm" @submit.prevent="startSearch">
        <div class="input-group custom-search-form">
          <input
            maxlength="50"
            type="text"
            class="form-control"
            placeholder="Искать"
            v-model.trim="searchData"
          />
          <span class="input-group-btn">
            <button
              v-if="searchWasApplied"
              class="btn btn-default"
              type="button"
              :disabled="isLoading"
              @click="dropSearch"
            >
              <i class="fa fa-refresh"></i>
            </button>
            <button
              class="btn btn-default"
              type="submit"
              :disabled="!searchData || isLoading"
            >
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </form>
      <Preloader v-if="isLoading" type="small" />
      <div
        v-if="list.length > 0 && !isLoading"
        class="table-responsive scroll-table table-responsive_long-list vert-scroll modal__table"
      >
        <table class="table">
          <thead>
            <tr>
              <th class="list__column_hidden">#</th>
              <th
                v-if="tableFields !== null"
                v-for="columnName in Object.values(tableFields)"
                :key="columnName"
                class="list__column"
              >
                {{ columnName }}
              </th>
              <th v-if="linkSlug && !withoutTableLinks" class="list__column">
                Ссылка
              </th>
            </tr>
          </thead>
          <tbody class="scroll-table-body">
            <tr v-for="item in list" :key="item.id">
              <td class="list__row">
                <input
                  type="checkbox"
                  name="list"
                  :id="item.name"
                  :value="notOnlyIds ? item : item.id"
                  v-model="selectedValues"
                />
              </td>
              <td
                v-if="tableFields !== null"
                v-for="rowName in Object.keys(tableFields)"
                :key="rowName"
                class="list__row"
              >
                {{ getRow(item[rowName], 20) }}
              </td>
              <td v-if="linkSlug && !withoutTableLinks" class="list__row">
                <router-link :to="`/${linkSlug}/${item.id}`" target="_blank">
                  <i class="fa fa-link" />
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="list.length > 0" class="tab__pagination">
        <Pagination
          :pages-counter="pagesCounter"
          :current-page="currentPage"
          :disabled="isLoading"
          @select="(value) => updateList(value, searchData)"
        />
      </div>
      <div
        v-if="!isLoading && list.length < 1"
        class="modal__body_empty-results"
      >
        <p>Ничего не найдено</p>
        <button
          v-if="searchWasApplied"
          type="button"
          class="btn btn-success"
          @click="dropSearch"
        >
          <b>Вернуться на первую страницу</b>
        </button>
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            type="button"
            class="modal-default-button btn btn-danger close-btn buttons__button_close-modal"
            @click="closeWithReseting"
          >
            Закрыть
          </button>
        </div>
        <div>
          <button
            v-if="!allowOnlyOneChoise"
            type="button"
            class="modal-default-button btn btn-success left-btn"
            @click="confirmChoice"
            :disabled="selectedValues.length < 1"
          >
            Выбрать
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Pagination from "@/_shared/components/ui/Pagination";
import Preloader from "@/_shared/components/ui/Preloader";
import Modal from "@/_shared/components/ui/Modal";
import { useModalSearch, useTableHelper } from "@/_shared/mixins";
export default {
  emits: ["choose", "close"],
  mixins: [useModalSearch, useTableHelper],
  components: {
    Pagination,
    Preloader,
    Modal,
  },
  props: {
    tableFields: {
      type: Object,
      default() {
        return {
          id: 'ID',
          name: 'Название',
        };
      },
    },
    title: {
      type: String,
      default: "",
    },
    notOnlyIds: {
      type: Boolean,
      default: false,
    },
    allowOnlyOneChoise: {
      type: Boolean,
      default: false,
    },
    withoutTableLinks: {
      type: Boolean,
      default: false,
    },
    withoutSearchForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedValues: [],
    };
  },
  watch: {
    show: {
      handler(value) {
        if (value) {
          document.querySelector("body").style.overflow = "hidden";
        }
      },
      immediate: true,
    },
    selectedValues(newValues) {
      if (this.allowOnlyOneChoise && newValues.length === 1) {
        this.$emit("choose", newValues[0]);
        this.close();
      }
    },
  },
  methods: {
    confirmChoice() {
      this.$emit("choose", this.selectedValues);
      this.closeWithReseting();
    },
    closeWithReseting() {
      this.resetSearchForm();
      this.close();
    },
    close() {
      this.selectedValues = [];
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.list__column_hidden {
  visibility: hidden;
}
.modal__table {
  margin-top: 1.5em;
}
.modal__body_empty-results {
  display: inline-flex;
  width: 100%;
  justify-content: center;
  padding-top: 6em;
  padding-bottom: 6em;
  flex-direction: column;
}
.modal__body_empty-results > p,
button {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/modals/EntityReferencesModal.vue